/**
 * Зависимости
 */
import {Utils} from '../../common/scripts/utils';
import YandexMap from '../../components/yandex-map';

/**
  * Карта
  */
const contactsMap = document.querySelector('.j-contacts-page-map');

let isLoaded = false;

const initContactsMap = () => {
    isLoaded = true;

    const ymaps = window.ymaps;

    if (ymaps) {
        ymaps.ready(() => {
            const yandexMap = new YandexMap(ymaps);

            yandexMap.init({
                wrapper                : contactsMap,
                cluster                : true,
                fullScreenControl      : true,
                customFullScreenControl: true,
                customZoomControl      : true
            });
        });
    }
};

// TODO: Функция дублируется в sections/developer-roadmap-map/index.js, sections/infrastructure/index.js, sections/location/index.js - вынести в утилиты, прописать ключ для карты
const checkMap = () => {
    const ymaps = window.ymaps;

    if (ymaps) {
        initContactsMap();
    } else {
        Utils.loadScript('https://api-maps.yandex.ru/2.1/?lang=ru_RU', initContactsMap);
    }
};

if (contactsMap) {
    if ('IntersectionObserver' in window) {
        const lazyImageObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    if (!isLoaded) {
                        checkMap();
                    }
                }
            });
        }, {rootMargin: '0px 0px 1000px 0px'});

        if (Utils.isInViewport(contactsMap, window.innerHeight || document.documentElement.clientHeight)) {
            checkMap();
        } else {
            lazyImageObserver.observe(contactsMap);
        }
    } else {
        checkMap();
    }
}


